import React, { useRef } from 'react'
import styled from 'styled-components'
import { useTable, Button, ChevronUpIcon, ColumnType } from 'toonswap-uikit'
import { useTranslation } from 'contexts/Localization'

import Row, { RowProps } from './Row'

export interface ITableProps {
  data: RowProps[]
  columns: ColumnType<RowProps>[]
  sortColumn?: string
}

const Container = styled.div`
  filter: ${({ theme }) => theme.card.dropShadow};
  width: 100%;
  background: transparent;
  border-radius: 16px;
  margin: 16px 0px;
`

const TableWrapper = styled.div`
  overflow: visible;

  &::-webkit-scrollbar {
    display: none;
  }
`

const StyledTable = styled.table`
  border-collapse: separate;
  border-spacing: 0 10px;
  font-size: 14px;
  border-radius: 4px;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
`

const TableBody = styled.tbody`
  & tr {
    td {
      font-size: 16px;
      vertical-align: middle;
    }
  }
`

const TableContainer = styled.div`
  position: relative;
`

const ScrollButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 5px;
  padding-bottom: 5px;
`

const PoolTable: React.FC<ITableProps> = (props) => {
  const tableWrapperEl = useRef<HTMLDivElement>(null)
  const { t } = useTranslation()
  const { data, columns } = props

  const { rows } = useTable(columns, data, { sortable: true, sortColumn: 'pool' })

  const scrollToTop = (): void => {
    tableWrapperEl.current?.scrollIntoView({
      behavior: 'smooth',
    })
  }

  return (
    <Container>
      <TableContainer>
        <TableWrapper ref={tableWrapperEl}>
          <StyledTable>
            <TableBody>
              {rows.map((row) => (
                <Row {...row.original} key={`table-row-${row.id}`} />
              ))}
            </TableBody>
          </StyledTable>
        </TableWrapper>
        {data.length > 15 && (
          <ScrollButtonContainer>
            <Button variant="text" onClick={scrollToTop}>
              <span style={{ color: '#ffffff' }}>{t('To Top')}</span>
              <ChevronUpIcon color="#ffffff" />
            </Button>
          </ScrollButtonContainer>
        )}
      </TableContainer>
    </Container>
  )
}

export default PoolTable
